module.exports = __webpack_public_path__ + "img/20.e551eb7b.png";